import "./ActivityLog.css";
import AlertMessage from "../AlertMessage";
import "react-native-get-random-values";
import { v4 as uuidv4 } from "uuid";
import DataLoader from "../DataLoader";

const ActivityLog = ({ res, error, isLoading }) => {

  return (
    <div className="act-sub-container ">
      <div className="act-title-group">
        <h3 className="act-title">Activity Log</h3>
      </div>
      <div>
        {!isLoading ? (
          !error ? (
            res?.length === 0 ? (
              <AlertMessage
                message="No Activity Events"
                level="info"
                closeEvt="false"
                mt="0"
                mb="0"
              />
            ) : (
              <>
                <div className="act-scroll-screen-y">
                  <div className="row ">
                    <div className="col-md-12">
                      <div className="act-input-group">
                        {res?.map((activityLog) => (
                          <div className="actInfoField" key={uuidv4()}>
                            {activityLog}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )
          ) : (
            <AlertMessage message={error} />
          )
        ) : (
          <DataLoader isLoading={isLoading} />
        )}
      </div>
    </div>
  );
};

export default ActivityLog;
